import React from 'react';
import { PropTypes } from 'prop-types';
import { Else, If, Then } from 'react-if';

import Form from './form';
import Results from './results';

import TpnCollection from '../../utility/tpn-collection';

const ERROR_MSG = "Something went wrong. Please wait a moment and try again";
const LOADING_MSG = "Searching..."

class Template extends React.Component {
  render(){
    const {
      search,
      getProviders,
      isFetching,
      hasError
    } = this.props;
    return (
      <div style={{display: 'flex'}}>
        <div style={{width: '15%'}}>
          <Form applySearchFilter={search} />
        </div>
        <div style={{width: '85%'}}>
          <h3>Providers</h3>
          <Results providers={getProviders()} />
          <If condition={isFetching()}>
            <Then>{ () => (
              <h5>{LOADING_MSG}</h5>
            )}
            </Then>
          </If> 
          <If condition={hasError()}>
            <Then>{ () => (
              <h5>{LOADING_MSG}</h5>
            )}
            </Then>
          </If>
        </div>
      </div>
    )
  }
}

Template.propTypes = {
  search: PropTypes.func,
  getProviders: PropTypes.func,
  isFetching: PropTypes.func
}

export default Template;
